import React, { FC } from 'react';
import manifest from './site.json';
import { SiteManifest, SiteModuleProps } from '../../customFrontend/types';
import BrandHome from '../../siteBrands/chatapp/BrandHome';
import BrandCityPage from '../../siteBrands/chatapp/BrandCityPage';
import BrandTopicPage from '../../siteBrands/chatapp/BrandTopicPage';
import { CITIES } from './cities';
import { HOME, LABELS } from './Home';
import { TOPICS } from './topics';

const site = manifest as SiteManifest;
const cities = Object.values(CITIES);
const topics = Object.values(TOPICS);

/** chatapp.nl: Dutch flirt and sex chat on the chatapp brand (`siteBrands/chatapp`). See ../CLAUDE.md. */
const ChatappNl: FC<SiteModuleProps> = ({ path }) => {
  const page = site.pages.find((candidate) => candidate.path === path) ?? site.pages[0]!;
  const city = CITIES[page.path];
  const topic = TOPICS[page.path];
  return (
    <div className="site-chatapp-nl brand-chatapp" lang={site.language}>
      {page.type === 'city' && city
        ? <BrandCityPage site={site} page={page} city={city} cities={cities} labels={LABELS} topics={topics} />
        : page.type === 'topic' && topic
          ? <BrandTopicPage site={site} page={page} topic={topic} cities={cities} labels={LABELS} topics={topics} />
          : <BrandHome site={site} page={page} copy={HOME} cities={cities} labels={LABELS} topics={topics} />}
    </div>
  );
};

export default ChatappNl;
